module.exports = __webpack_public_path__ + "img/credito-simple-os.e1b6e880.webp";